module.exports = __webpack_public_path__ + "img/age-group_3787841.0d158da9.png";